import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.capcmortgages.co.uk";
const SITE_NAME = "CAPC Mortgages";
const DEFAULT_IMAGE = `${SITE_URL}/logo.png`;
const DEFAULT_IMAGE_ALT = "CAPC Mortgages logo";

const SEO = ({ title, description, path = "/" }) => {
  const pageTitle = title.includes(SITE_NAME) ? title : `${title} | ${SITE_NAME}`;
  const canonicalPath = path.startsWith("/") ? path : `/${path}`;
  const canonicalUrl = `${SITE_URL}${canonicalPath === "/" ? "" : canonicalPath}`;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <meta name="author" content={SITE_NAME} />
      <meta name="application-name" content={SITE_NAME} />
      <link rel="canonical" href={canonicalUrl} />

      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:image:width" content="190" />
      <meta property="og:image:height" content="83" />
      <meta property="og:image:alt" content={DEFAULT_IMAGE_ALT} />
      <meta property="og:locale" content="en_GB" />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={DEFAULT_IMAGE} />
      <meta name="twitter:image:alt" content={DEFAULT_IMAGE_ALT} />

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FinancialService",
          name: SITE_NAME,
          url: SITE_URL,
          logo: DEFAULT_IMAGE,
          description,
          address: {
            "@type": "PostalAddress",
            streetAddress: "7 Arrow Court",
            addressLocality: "Alcester",
            postalCode: "B49 6PU",
            addressCountry: "GB",
          },
        })}
      </script>
    </Helmet>
  );
};

export default SEO;
